import Breadcrumb from "@/components/base/Breadcrumb";
import type { CategoryMeta } from "@/types/content";

export default function CategoryHeader({ meta }: { meta: CategoryMeta }) {
  return (
    <div className="w-full bg-background-100 border-b border-background-200">
      <div className="w-full px-4 md:px-8 py-6 md:py-8">
        <Breadcrumb items={[{ label: "首页", to: "/" }, { label: meta.name }]} />
        <div className="flex items-start gap-4 mt-5">
          <span className="hidden sm:flex w-14 h-14 rounded-xl bg-primary-100 items-center justify-center shrink-0">
            <i className={`${meta.icon} text-3xl text-primary-600`} />
          </span>
          <div>
            <h1 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 mb-2">
              {meta.name}
            </h1>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-3xl">
              {meta.description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}